<div class="card-wrap">
  <div class="fundraiser-wrap">
    <div class="inner-fund">
      <div class="head">
        <div class="title">Campaigns</div>
        <div class="view-all"><a [routerLink]="'/all-fundraisers'"><button mat-button>View All</button></a></div>
      </div>
      <div class="bot-border"></div>
      <ol class="fundraisers">
        <li *ngFor="let item of fundraisersList" [hidden]="!item?.status_running">
          <a [routerLink]="'/stories/'+item?.custom_tag" [queryParams]="{payment: 'form'}">
            <div class="fundraiser-card">
              <div class="fund-image"><img loading="lazy" [attr.data-src]="item?.leaderboard?.cdn_path" [default]="util.defaultImg" alt="image"></div>
              <div class="type-nudge"><span>{{item?.cause?.info_1}}</span></div>
              <div class="fund-details">
                <div class="title" [innerHTML]="item?.title"></div>
                <div class="patform">
                  <img loading="lazy" [attr.data-src]="util?.logoUrlDark" alt="image">
                  <span>by</span>
                  <a href="https://support.childhelpfoundation.in/ngo/ngo_details.php?fmd_id=409046">CHILD HELP FOUNDATION </a>
                </div>
              </div>
              <div class="blankspace"></div>
              <div *ngIf="taxBenefit" class="ribbon">
                <span>Tax benefit</span>
              </div>
            </div>
          </a>
        </li>
      </ol>
    </div>
  </div>
</div>